var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#8cc3d5;}.b{fill:#8cc3d5;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.465)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-0.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 22,
    cy: 22,
    r: 21.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.637 11.687)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.154,11.564c0,6.134-4.2,10.5-10.4,10.5a10.75,10.75,0,0,1,0-21.5,10.338,10.338,0,0,1,7.209,2.813L15.033,6.189C11.206,2.5,4.088,5.27,4.088,11.313A6.734,6.734,0,0,0,10.75,18.1a5.813,5.813,0,0,0,6.1-4.634h-6.1V9.77H20.985A9.424,9.424,0,0,1,21.154,11.564Z",
    transform: "translate(0 -0.563)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0ffa36f3.svg";
export { ForwardRef as ReactComponent };